import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';

interface ITransportDisplayWidgetProps {
    input: string;
    lang: string;
}

interface ITransportDisplayWidgetState {
    transformedInput: string;
}

export class TransportDisplayWidget extends Component<
    ITransportDisplayWidgetProps,
    ITransportDisplayWidgetState
> {
    constructor(props: ITransportDisplayWidgetProps) {
        super(props);
        this.state = {
            transformedInput: this.props.input.replace(
                /(\[)(\d+)(\])/g,
                "<a target='_blank' href='//www.stib-mivb.be/horaires-dienstregeling2.html?l=" +
                    this.props.lang +
                    "&_line=$2&_directioncode=V' style='' class='text-decoration-none line line--$2'>" +
                    '$2' +
                    '</a>'
            ),
        };
    }

    render() {
        return (
            <div
                className="transport-details"
                dangerouslySetInnerHTML={{
                    __html: this.state.transformedInput,
                }}
            ></div>
        );
    }
}

WidgetHelper.register(TransportDisplayWidget, 'transport-display-widget');
